import { graphql } from 'relay-runtime';

export const getAllSkills = graphql`
  query SkillsAllSkillsQuery(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $searchQuery: String!
    $skip: Boolean = false
    $ancestriesIds: [ID!]
  ) {
    searchSkills(searchQuery: $searchQuery, first: $first, after: $after, last: $last, before: $before)
      @skip(if: $skip) {
      nodes {
        id
        name
        assessmentInfo
        summary
        code
        standards {
          id
          longName
        }
        skillAncestries(filter: { skillRelevanceIds: $ancestriesIds }) {
          skillRelevance {
            id
          }
          ancestorSkill {
            id
            name
            code
          }
        }
        lessons(filter: { lessonTypeIds: ["LessonTypeNode:11"], isActive: true }) {
          id
        }
        targetGroups {
          id
          name
        }
        targets {
          id
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const getSkillInfoByCode = graphql`
  query SkillsTeacherSingleSkillByCodeQuery($skillCode: String!, $skip: Boolean!) {
    siteSpecificSkillInfoBySkillCode(skillCode: $skillCode) @skip(if: $skip) {
      name
      id
      code
      summary
      assessmentInfo
      essentialQuestion
      context
      vocabularies {
        id
        term
        definition
      }
      skillStories {
        id
        profession
        story
        description
      }
      standards {
        id
        description
        longName
      }
    }
  }
`;

export const getLessonsByType = graphql`
  query SkillsLessonByTypeQuery($filter: LessonSkillsFilterInput!) {
    lessonSkills(filter: $filter, order: [{ lesson: { type: { name: ASC } } }]) {
      nodes {
        id
        isActive
        lesson {
          teacherOnly
          id
          summary
          url
          spanishUrl
          name
          type {
            name
            id
          }
        }
      }
    }
  }
`;

export const skillProgressReportStudentsQuery = graphql`
  query SkillsProgressReportStudentsQuery(
    $filter: SkillProgressReportStudentsFilterInput!
    $skip: Boolean = false
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    skillProgressReportStudents(filter: $filter, first: $first, after: $after, last: $last, before: $before)
      @skip(if: $skip) {
      nodes {
        id
        firstName
        lastName
        publicUserId
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
      }
    }
  }
`;

export const getAllTargetSkillTypes = graphql`
  query SkillsAllTargetSkillTypesQuery {
    allTargetSkillTypes {
      id
      name
      isActive
    }
  }
`;

export const skillsProgressTableQuery = graphql`
  query SkillsProgressTableQuery(
    $filter: AllSkillsFilterInput!
    $skip: Boolean = false
    $first: Int
    $after: String
    $last: Int
    $before: String
    $targetGroupsIds: [ID!]
  ) {
    allSkills(filter: $filter, first: $first, after: $after, last: $last, before: $before) @skip(if: $skip) {
      nodes {
        id
        name
        code
        targetSkills(filter: { targetGroupIds: $targetGroupsIds, isActive: ACTIVE }) {
          id
          target {
            id
            name
            targetGroup {
              id
              name
            }
          }
          targetSkillType {
            id
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
      }
      totalCount
    }
  }
`;

export const skillsResultsReport = graphql`
  query SkillsResultsReportQuery($filter: SkillsProgressReportFilterInput!, $skip: Boolean = false) {
    skillsProgressReport(filter: $filter) @skip(if: $skip) {
      skill {
        id
      }
      skillsResults {
        key
        value
      }
    }
  }
`;

export const getPresignedURLsForSkill = graphql`
  query SkillsPresignedURLsQuery($skillCode: String!, $filter: PresignedUrlsForSkillFilterInput!) {
    presignedURLsForSkill(skillCode: $skillCode, filter: $filter) {
      workedExampleVideoUrl
      practiceProblemsUrl
      revealMathAlignmentUrl
      illustrativeMathAlignmentUrl
      workedExampleVideoEnglishCaptionUrl
      workedExampleVideoSpanishCaptionUrl
    }
  }
`;

// Everything the guided-tour demo page needs in one round trip. The three roots are
// independent; querying them separately with useLazyLoadQuery would suspend serially.
// searchSkills stands in for the student-scoped support-skills query: there is no
// student in the tour, and the prerequisite ancestries (identity only) are enough.
export const getGuidedTourContent = graphql`
  query SkillsGuidedTourContentQuery(
    $skillCode: String!
    $urlsFilter: PresignedUrlsForSkillFilterInput!
    $ancestriesIds: [ID!]
  ) {
    siteSpecificSkillInfoBySkillCode(skillCode: $skillCode) {
      name
      id
      code
      summary
      assessmentInfo
      essentialQuestion
      context
      vocabularies {
        id
        term
        definition
      }
      skillStories {
        id
        profession
        story
        description
      }
      standards {
        id
        description
        longName
      }
    }
    presignedURLsForSkill(skillCode: $skillCode, filter: $urlsFilter) {
      workedExampleVideoUrl
      workedExampleVideoEnglishCaptionUrl
      workedExampleVideoSpanishCaptionUrl
    }
    searchSkills(searchQuery: $skillCode) {
      nodes {
        code
        skillAncestries(filter: { skillRelevanceIds: $ancestriesIds }) {
          skillRelevance {
            id
          }
          ancestorSkill {
            id
            name
            code
          }
        }
      }
    }
  }
`;
